import { useQuery } from "@apollo/client";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { GET_RENTALS, GET_USER_DETAILS } from "../../apollo/operations";
import { RentalType, VehicleType } from "../../types";
import { showToast } from "../../utils/showToast";
import { calculateAge } from "../../utils/daysBetweenDates";
import { RootState } from "../../redux/store";

type FeaturesProps = {
  vehicle: VehicleType;
};

const CarPricing: React.FC<FeaturesProps> = ({ vehicle }) => {
  const user = useSelector((state: RootState) => state.user.userDetails);
  // console.log(user);

  const { data } = useQuery(GET_RENTALS, {
    variables: {
      where: {
        lessee: {
          id: user?.id,
        },
      },
    },
    onCompleted(data) {
      console.log("Rental data", data);
    },
    onError(error) {
      console.log("Rental error", error);
    },
  });

  const navigate = useNavigate();

  const handleNavigate = (): void => {
    // console.log(user, data);
    if (!user) return navigate("/auth");
    if (!data) return;
    if (user && user.userOnboardingStatus === "VerifyDriverLicense") {
      //TODO: Update this implementation to use the user's date of birth
      const userAge = user?.driverLicense.dateOfBirth
        ? calculateAge(user?.driverLicense.dateOfBirth)
        : 0;

      const minAge = vehicle.vehicleCategory?.minAge;

      // console.log(userAge, minAge);
      if (userAge < 21) {
        showToast(
          `You must be at least 21 years old to lease vehicles on Ecomoto`,
          "error"
        );
        return;
      }

      if (userAge < minAge) {
        showToast(
          `You must be at least ${minAge} years old to lease a ${vehicle?.vehicleCategory?.name} vehicle`,
          "error"
        );
        return;
      }

      const availableDates = vehicle.availability
        .map((date) => new Date(date))
        .sort((a, b) => a.getTime() - b.getTime());

      if (new Date(availableDates[availableDates.length - 1]) < new Date()) {
        return showToast(
          `Sorry, this vehicle is not available for lease at the moment`,
          "error"
        );
      }

      const hasActiveRental = data?.rentals.some(
        (rental: RentalType) => rental.rentalStatus === "Active"
      );

      if (hasActiveRental) {
        showToast(
          `You have an active rental. Please return the vehicle before leasing another one`,
          "error"
        );
        return;
      }

      navigate(`/vehicles/rental/${vehicle.id}`);
    } else if (user && user.userOnboardingStatus !== "VerifyDriverLicense") {
      showToast(
        `Kindly verify your profile before leasing your favorite ${vehicle.make} ${vehicle.model}`,
        "error"
      );
      setTimeout(function Navigate() {
        navigate("/dashboard");
      }, 3000);
    } else if (!user) {
      navigate("/auth");
    }
  };

  return (
    <div className="flex justify-between ">
      <div className="flex flex-col ">
        <p className=" text-[#1a202c] font-Jakarta text-[28px] font-bold ">
          ${vehicle.pricePerHour} /{" "}
          <span className=" text-[16px] text-[#90a3bf]  ">day</span>
        </p>
      </div>
      {/* <Link to={user ? `/vehicles/rental/${vehicle.id}` : "/auth"}> */}
      <button
        type="button"
        className=" cursor-pointer font-Jakarta font-bold text-base text-[#fff] text-center flex items-center border rounded-xl p-[20px] bg-midGreen "
        onClick={handleNavigate}
      >
        Book Now
      </button>
      {/* </Link> */}
    </div>
  );
};

export default CarPricing;
